import actions from "actions/actionTypes";

export const sanitizeFieldsAction = fields => {
  return {
    type: actions.SANITIZE_FIELDS,
    payload: fields
  };
};

export const sanitizeFieldsSuccessAction = fields => {
  return {
    type: actions.SANITIZE_FIELDS_SUCCESS,
    payload: fields
  };
};

export const sanitizeFieldsFailureAction = error => {
  return {
    type: actions.SANITIZE_FIELDS_FAILURE,
    payload: error
  };
};
